<influencer-module-container [title]="'INFLUENCER.overview.brand_mentions.title' | translate"
    [hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
    [placeholderWidth]="361"
    [printMode]="printMode">

    <div class="brand-mentions-container" 
        [class.placeholder]="hasNoData" 
        [class.print-mode]="printMode">
        <ng-container *ngIf="!hasNoData && !isFetchingData">
            <div *ngFor="let mention of brandMentions" class="brand-mention-item">
                <span class="brand-mention-label">{{mention}}</span>
            </div>
        </ng-container>

        <ng-container *ngIf="hasNoData || isFetchingData">
            <ng-container *ngFor="let size of placeHolderSizes">
                <div class="brand-mention-item size-{{size}}"></div>
            </ng-container>
        </ng-container>
    </div>
</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/brand-mentions/brand-mentions.component.html